import Extend from 'flarum/common/extenders';
import Model from 'flarum/common/Model';
import Discussion from 'flarum/common/models/Discussion';
import ForumsPage from './components/ForumsPage';
import StatusChangedPost from './components/StatusChangedPost';
export default [new Extend.Routes().add('sublace.forums', '/forums', ForumsPage), new Extend.PostTypes().add('sublaceStatusChanged', StatusChangedPost), new Extend.Model(Discussion).attribute('sublaceStatus').attribute('sublaceStatusAt', Model.transformDate).attribute('canSublaceStatus')];